export enum TabKeys {
  FOLDERS = "FOLDERS",
  FORMS = "FORMS",
}
